export default __webpack_public_path__ + "static/media/oculus.8486a751.png";